import { render, staticRenderFns } from "./RelationEllipse.vue?vue&type=template&id=4332a478&scoped=true&"
import script from "./RelationEllipse.vue?vue&type=script&lang=ts&"
export * from "./RelationEllipse.vue?vue&type=script&lang=ts&"
import style0 from "./RelationEllipse.vue?vue&type=style&index=0&id=4332a478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332a478",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VImg,VSelect})
